module.exports = __webpack_public_path__ + "img/corporation.0133203.svg";